import { Component, Inject, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { StrapiService } from '../../../common/services/strapi.service';
import { AuthService } from '../../../common/services/auth.service';
import { AppSettings } from '../../../common/constants/appSettings.constants';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackbarNotification } from '../../notifications/snackbar-notification/snackbar-notification.component';
import { SiteService } from '../../../common/services/site.service';
import { RecaptchaService } from '../../../common/services/recaptcha.service';

@Component({
    selector: 'app-request',
    templateUrl: './login.component.html',
    styleUrls: ['../user.shared.scss', './login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {
  baseHref: string;
  username: string;
  password: string;
  errorMessage: string;
  loading: boolean = false;
  showPassword: boolean = false;
  snackBar: MatSnackBar = new MatSnackBar();
  constructor(
      private strapiService: StrapiService,
      private authService: AuthService,
      private siteService: SiteService,
      private recaptchaService: RecaptchaService,
    ) {
    this.baseHref = environment.assetBaseHref;
  }

  ngOnInit() {
    // Force dark mode on user pages.
    this.siteService.updateTheme( 'dark-mode' );
    // console.log('Base Href:', this.baseHref);

  }

  async onLogin() {
    // console.log('call strapi login method');
    this.loading = true;

    const token = await this.recaptchaService.execute('userLogin');

    this.strapiService.login({ username: this.username, password: this.password, token }).subscribe({
      next: (response) => {
        // console.log( 'login response', response);
        this.loading = false;
        if( response.status == 'success' ) {
          // Manage logged in status
          this.authService.login( response.token );

        } else  {
          const notification = {
              "severity": "alert",
              "header": "Not Recognized",
              "message": AppSettings.messages.login.failure
          }
          
          // this.errorMessage = AppSettings.messages.login.failure;
          this.snackBar.openFromComponent(SnackbarNotification, {
            data: notification,
            duration: 3000,
            horizontalPosition: "center",
            verticalPosition: "top"
          });
        }

      },
      error: (error) => {
        console.error('Login failed', error);
        const notification = {
          "severity": "alert",
          "header": "Not Recognized",
          "message": AppSettings.messages.login.failure
        }
        // this.errorMessage = AppSettings.messages.login.failure;
        this.snackBar.openFromComponent(SnackbarNotification, {
          data: notification,
          duration: 3000,
          horizontalPosition: "center",
          verticalPosition: "top"
        });

      }
    });
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }
}
